<p-confirmDialog key="addperson" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Heading-->
<div style="text-align: center">
	<h2>
		Add for Reminder:
		<span [style.color]="MessageFontColor">{{ Message }}</span>
	</h2>
</div>

<!--Person Selector-->
<div class="TopMarginExtra MaxWidth">
	<p-accordion>
		<p-accordionTab
			header="Select Students and Staff {{ SelectStudentExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="SelectStudentExpand"
		>
			<div>
				<caass-personselector
					[UpdateSchoolSelector]="false"
					[AudienceID]="1"
					[CanSwitchAudience]="true"
					[ShowAllSchools]="false"
					[MultiSelect]="true"
					[buttonMultiSelectProcessCaption]="'Add to List'"
				></caass-personselector>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--Table to add-->
<div class="TopMarginExtra MaxWidth">
	<p-accordion>
		<p-accordionTab
			header="Students and Staff to Assign ({{ lstPerson.length }}) {{ StudentsToAddExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="StudentsToAddExpand"
		>
			<div>
				<caass-reminder-students-to-add
					[loading]="IsLoading() == true"
					[lstPerson]="lstPerson"
					(RemoveAll)="onRemoveAll()"
					(RemovePerson)="onRemovePerson($event)"
				>
				</caass-reminder-students-to-add>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Assign Reminder</button>
	<button [disabled]="Processing == true" class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Close</button>
</div>
